import { useStateMachine } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import { StyledFormGroup } from '../../../../../Components/Reuseables';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../../_helpers/_methods';
import updateAction from './updateAction';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import NavigationButtonGroup from '../../../../admin/Events/Steps/components/NavigationButtonGroup';

function OrganizationStep2() {
  const lang = useSelector((state) => state?.local?.local);
  const rosterData = useSelector((state) => state.rosters.rosters);
  const { id, edit: isEdit } = useParams();
  const [options, setOptions] = useState([]);
  const [thematicArea, setThematicArea] = useState([]);

  useEffect(() => {
    const getThematicArea = async () => {
      try {
        let response = await fetchWrapper.get('/thematicarea/?limit=100');
        response = response.data.results.map((thematicarea) => {
          return {
            label: thematicarea.title_nepali,
            value: thematicarea?.title_nepali,
            id: thematicarea?.id,
            name: thematicarea?.title_nepali
          };
        });
        setOptions(response);
      } catch (error) {
        ErrorMessageHandler(error);
      }
    };
    getThematicArea();
  }, []);

  const handleChange = (e) => {
    console.log(e.target.value, 'value');
  };

  const { actions } = useStateMachine({ updateAction });
  const { state } = useStateMachine({ updateAction });
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });

  useEffect(() => {
    if (isEdit) {
      if (rosterData && Array.isArray(rosterData?.user?.expertise)) {
        const expert = rosterData.user.expertise.map((expertise) => ({
          id: expertise.thematic_area
        }));
        setThematicArea(expert);
      }
    }
  }, [rosterData]);

  const location = useLocation();
  const onSubmit = (data) => {
    data = { ...data, thematicArea };
    actions.updateAction(data);
    let path = location.pathname.split('/');

    if (isEdit) {
      navigate(`/admin/rosters/organization/${id}/edit/3`);
    } else {
      path.includes('admin')
        ? navigate('/admin/rosters/organization_apply/3')
        : navigate('/rosters/organization_apply/3');
    }
  };

  const handleCheckBox = (e) => {
    let tempThematicArea = [...thematicArea];
    if (e.target.checked) {
      tempThematicArea.push({ id: +e.target.id });
    } else {
      tempThematicArea = tempThematicArea.filter((item) => {
        return +item.id !== +e.target.id;
      });
    }
    setThematicArea(tempThematicArea);
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="">
          <div className="mt-4">
            <h3 className="">
              <FormattedMessage id="thematic_area_and_related_experience" />
            </h3>
          </div>
          <div className="">
            <FormattedMessage id="choose_thematic_area" />
          </div>
          <div className="row">
            <div className="col-md-12 ">
              {options.map((option, index) => {
                return (
                  <StyledFormGroup className="list-group-item" key={index}>
                    <div>
                      <FormGroup
                        type="checkbox"
                        id="thematic_area"
                        onChange={(e) => handleCheckBox(e)}
                        options={[option]}
                        checked={thematicArea.find((item) => +item.id === option.id) ? true : false}
                        defaultValue={state?.thematic_area}
                        register={register}
                        error={errors}
                      />
                    </div>
                  </StyledFormGroup>
                );
              })}
            </div>
            <h5 className="mb-2 mt-3">
              <FormattedMessage id="capacity_development_training" />
            </h5>
            <div className="col-md-12">
              <StyledFormGroup className="list-group-item ">
                <FormGroup
                  type="radio"
                  id="roster_capacity_increasae_experience"
                  register={register}
                  error={errors}
                  onChange={(e) => handleChange(e)}
                  options={[
                    {
                      label: lang === 'ne' ? 'छ' : 'Yes',
                      value: 'yes',
                      id: 'roster_capacity_increasae_experience_yes',
                      name: 'roster_capacity_increasae_experience'
                    },
                    {
                      label: lang === 'ne' ? 'छैन' : 'No',
                      value: 'no',
                      id: 'roster_capacity_increasae_experience_',
                      name: 'roster_capacity_increasae_experience'
                    }
                  ]}
                />
              </StyledFormGroup>
            </div>
          </div>
        </div>
        <div className="">
          <hr />
          <NavigationButtonGroup
            backTo="/admin/rosters/organization_list"
            // showSubmit={id}
          />
        </div>
      </form>
    </div>
  );
}

export default OrganizationStep2;
